window.BundleUI = (() => {

    const count = document.getElementById("bundle-count");
    const container = document.getElementById("bundle-items");
    const checkout = document.getElementById("bundle-checkout");

    function formatMoney(cents) {
        const currency =
            window.Shopify?.currency?.active ||
            window.Shopify?.Checkout?.currency ||
            document.documentElement.getAttribute("data-currency") ||
            "USD";
        return new Intl.NumberFormat(undefined, {
            style: "currency",
            currency: currency
        }).format(cents / 100);
    }

    function floor5(n) {
        return Math.floor(n / 5) * 5;
    }

    function render() {

        const items = BundleState.getItems();

        // Original price = sum of the items' full (compare-at) prices.
        const original = items.reduce((sum, item) => sum + (item.compare || item.price), 0);
        const bundleSum = items.reduce((sum, item) => sum + (item.bundle || item.price), 0);
        // With all 3 items the real bundle price applies; before that show the pro-rata price.
        const total = items.length === 3 ? Number(window.BundleConfig.bundlePrice) : bundleSum;
        const savings = Math.max(0, original - total);
        const pct = original > 0 ? floor5(Math.floor((savings / original) * 100)) : 0;

        const totalsEl = document.getElementById("bundle-totals");
        const subtotalEl = document.getElementById("bundle-subtotal");
        const savingsEl = document.getElementById("bundle-savings");
        const bundlePriceEl = document.getElementById("bundle-price");
        const pctEl = document.getElementById("bundle-pct");

        if (totalsEl) totalsEl.hidden = items.length === 0;
        if (bundlePriceEl) bundlePriceEl.textContent = formatMoney(total);
        if (subtotalEl) subtotalEl.textContent = formatMoney(original);
        if (savingsEl) savingsEl.textContent = "-" + formatMoney(savings);
        if (pctEl) pctEl.textContent = pct > 0 ? "(" + pct + "%)" : "";

        count.textContent = items.length;

        const fill = document.getElementById("bundle-progress-fill");

        if (fill) {
            fill.style.width = `${(items.length / 3) * 100}%`;
        }

        container.innerHTML = "";

        if (items.length === 0) {

            container.innerHTML = `
                <div class="bundle-empty">
                    <div class="bundle-empty__title">No items added yet</div>
                    <div class="bundle-empty__sub">Select exactly 3 products across the collections to unlock your bundle.</div>
                </div>
            `;

        } else {

            items.forEach(item => {

                const hasDisc = item.compare && item.bundle && item.compare > item.bundle;

                container.innerHTML += `
                    <div class="bundle-item">
                        <div class="bundle-item__media">
                            <img src="${item.image}" alt="${item.title}" />
                            ${item.size ? `<span class="bundle-item__size">${item.size}</span>` : ""}
                        </div>
                        <div class="bundle-item__info">
                            <div class="bundle-item__title">${item.title}</div>
                            ${hasDisc ? `<div class="bundle-item__prices"><span class="bundle-item__now">${formatMoney(item.bundle)}</span><span class="bundle-item__was">${formatMoney(item.compare)}</span></div>` : ""}
                        </div>
                        <button type="button" class="bundle-remove" data-product-id="${item.productId}" aria-label="Remove">&times;</button>
                    </div>
                `;

            });

        }

        updateButtons(items);

        if (items.length === 3) {
            checkout.textContent = "Add Bundle To Cart";
            checkout.disabled = false;
        } else {
            const remaining = 3 - items.length;
            checkout.textContent = "Select " + remaining + " more item" + (remaining === 1 ? "" : "s");
            checkout.disabled = true;
        }

        bindRemove();

    }

    function updateButtons(items) {

        const selectedProducts = items.map(item => String(item.productId));

        document.querySelectorAll(".bundle-add").forEach(button => {

            const id = String(button.dataset.productId);

            if (selectedProducts.includes(id)) {

                button.textContent = "✓ Added";
                button.disabled = true;
                button.classList.add("is-added");

            } else {

                button.textContent = "Add to Bundle";
                button.disabled = false;
                button.classList.remove("is-added");

            }

        });

    }

    function bindRemove() {

        document.querySelectorAll(".bundle-remove").forEach(button => {

            button.addEventListener("click", () => {

                BundleState.remove(button.dataset.productId);

                render();

            });

        });

    }

    return {
        render
    };

})();
